{
  "0031ddd1d1262240": "Transferir DNR entre lugares de trabajo",
  "01d8efda72cd3d07": "Motivo de eliminación",
  "0896420838398301": "El lugar de trabajo de origen no tiene DNR para copiar.",
  "09fd2948a8dffd21": "Lugar de trabajo",
  "10d20e340181a52f": "Seleccionar todos los que apliquen",
  "12d9815fef885712": "Lugar de trabajo de origen",
  "155f816c0407310c": "Enviar",
  "19766ed6ccb2f4a3": "Cancelar",
  "1f788a0ac35935a7": "Buscar lugar de trabajo de origen",
  "24fea1562512ef18": "Lista de DNR",
  "29e53f7f6b5bff7d": "Los lugares de trabajo de origen y destino deben ser diferentes.",
  "322d9f6cd4c0ce6a": "Lugar de trabajo de destino",
  "38c1d970ac4a549b": "Lugar de trabajo desconocido",
  "39086c62b8953f38": "Motivos:",
  "3eea447b9a0f6500": "Copiar todos los DNR de un lugar de trabajo de origen a un lugar de trabajo de destino. Los trabajadores que ya tienen DNR en el lugar de trabajo de destino serán omitidos.",
  "4aadd98175f7d02c": "Agregar DNR",
  "4b8e893689d8dc65": "Buscar lugar de trabajo de destino",
  "6031ee797185af1e": "Comience a escribir el nombre del lugar de trabajo...",
  "6feb9cfbce4c4fb9": "Seleccionar un lugar de trabajo para agregar a la lista de DNR para este trabajador.",
  "712da63171e0c9de": "Desbloquear",
  "72ed245d2cf11822": "Motivos",
  "8a7525b1492fb848": "Notas",
  "95a1a159ad1b6bb7": "Ingrese el motivo de la eliminación...",
  "9688369e4a3c1d45": "Error al cargar los datos de DNR. Por favor, inténtalo de nuevo.",
  "9acd5ca87a2df72c": "Agregado {{createdDate}}",
  "9f90b6a53e10a134": "No se pudo eliminar el registro DNR",
  "b3122b441bb9c72b": "¿Eliminar este registro de DNR?",
  "b75b00f46e72dc5e": "Grabado Por",
  "c7ee9ee512665837": "Eliminar DNR",
  "c9eea6fa483c8dec": "Eliminar registro de DNR",
  "cc2111dd92b635db": "Buscando lugares de trabajo...",
  "d515313ac37e7359": "Registro DNR eliminado",
  "da4f7ea58d963b1a": "Notas:",
  "de5541d57b4ee198": "Esta entrada será eliminada permanentemente y el trabajador podrá ser asociado a este lugar de trabajo nuevamente.",
  "de98a1aeef07296d": "Ingrese notas adicionales...",
  "e2d0a54968ead24e": "Eliminar",
  "e87ced5e089eba2b": "ID: {{id}}",
  "ebe8d8f42b26353a": "Ordenar por {{columnLabel}}, actualmente {{sortState}}",
  "f30d0fbd79351450": "No se encontraron registros de DNR para este trabajador",
  "f81ab834de5f8491": "Razón",
  "ffb2623aad3197de": "Fecha de Creación"
}
